<template>
    <v-app>
        <v-banner
            v-if="deferredPrompt"
            color="info"
            dark
            class="text-left"
        >
            Installez ma PWA afin d'en profiter lorsque vous êtes hors ligne !

            <template #actions>
                <v-btn
                    text
                    @click="dismiss"
                >
                    Refuser
                </v-btn>
                <v-btn
                    text
                    @click="install"
                >
                    Installer
                </v-btn>
            </template>
        </v-banner>
        <v-main>
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
import Cookies from 'js-cookie';

export default {
    name: 'App',
    data() {
        return {
            deferredPrompt: null
        };
    },
    created() {
        if (!('serviceWorker' in navigator)) {
            console.log('Service Worker not supported');
            return;
        }

        window.addEventListener('beforeinstallprompt', e => {
            e.preventDefault();
            // Stash the event so it can be triggered later.
            if (Cookies.get('add-to-home-screen') === undefined) {
                this.deferredPrompt = e;
            }
        });
        window.addEventListener('appinstalled', () => {
            this.deferredPrompt = null;
        });
        if (this.$workbox) {
            this.$workbox.addEventListener('waiting', () => {
                this.showUpdateUI = true;
            });
        }
    },
    methods: {
        async dismiss() {
            Cookies.set('add-to-home-screen', null, { expires: 15 });
            this.deferredPrompt = null;
        },
        async install() {
            this.deferredPrompt.prompt();
        },
        async accept() {
            this.showUpdateUI = false;
            await this.$workbox.messageSW({ type: 'SKIP_WAITING' });
        }
    }
};
</script>

<style lang="scss">
</style>
